import { PresetFrame, type PresetArtProps } from './PresetFrame';

export function Rabbit(props: PresetArtProps) {
  return (
    <PresetFrame background="#db2777" {...props}>
      <ellipse cx="25" cy="19" rx="4.5" ry="11" fill="#ffffff" />
      <ellipse cx="39" cy="19" rx="4.5" ry="11" fill="#ffffff" />
      <circle cx="32" cy="40" r="14" fill="#ffffff" />
      <circle cx="27" cy="38" r="2.5" fill="#1f2937" />
      <circle cx="37" cy="38" r="2.5" fill="#1f2937" />
      <circle cx="32" cy="44" r="2" fill="#1f2937" />
    </PresetFrame>
  );
}
